import React, { Fragment } from 'react';
import sanitizeHtml from '../../Utils/sanitizeHtml';

const P = (props) =>{
    return(
      <Fragment>
        {props.innerHtml ? <p dangerouslySetInnerHTML={{ __html:sanitizeHtml(props.innerHtml) }} />
       : ''}
        <p {...props.attrPara} >{props.children}</p>
      </Fragment>
    );
};

export default P;